<template>
  <div>
    <b-modal ref="modal" title="Editar Dados da Empresa" header-class="border-bottom-0" size="xl">
      <div class="row">
        <div class="col-md-3">
          <h5 class="text-primary">
            <i class="fas fa-address-card" /> Dados da empresa
          </h5>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-6">
          <text-input
            :alias="form.name.alias"
            :form="form"
            :name="'name'"
            v-model="form.name.value" />
        </div>
        <div class="col-md-6">
          <text-input :alias="form.alias.alias" v-model="form.alias.value" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <mask-input :alias="form.cnpj.alias" v-model="form.cnpj.value" :mask="'cnpj'"/>
        </div>
        <div class="col-md-3">
          <text-input
            :alias="form.inscricao_estadual.alias"
            v-model="form.inscricao_estadual.value"
          />
        </div>
        <div class="col-md-1 d-flex align-items-end" style="padding-left:0px">
          <div class="form-group">
            <b-form-checkbox
            switch
            v-model="form.inscricao_estadual_isento.value"
            :value="1"
            :unchecked-value="0"
            >Isento</b-form-checkbox>
          </div>
        </div>
        <div class="col-md-4">
          <text-input
            :alias="form.inscricao_municipal.alias"
            v-model="form.inscricao_municipal.value"
          />
        </div>
      </div>
      <hr />
      <!-- Address -->
      <div class="row">
        <div class="col-md-3">
          <h5 class="text-primary">
            <i class="fas fa-map-marked-alt" /> Endereço
          </h5>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-8 col-md-6">
          <text-input v-model="form.address.value" :alias="form.address.alias" />
        </div>
        <div class="col-4 col-md-2">
          <text-input v-model="form.number.value" :alias="form.number.alias" />
        </div>
        <div class="col-md-4">
          <text-input v-model="form.complement.value" :alias="form.complement.alias" />
        </div>
      </div>
      <div class="row">
        <div class="col-8 col-md-4">
          <text-input v-model="form.district.value" :alias="form.district.alias" />
        </div>
        <div class="col-4 col-md-2">
          <mask-input v-model="form.zipcode.value" :mask="'cep'" :alias="form.zipcode.alias" />
        </div>
        <div class="col-md-4">
          <search-input
            :alias="form.city_id.alias"
            v-model="form.city_id.value"
            :displayedValue="form.city.value"
            :form="form"
            :name="'city_id'"
            @search="searchCity($event)"
            :searchResult="searchCityResults"
            :isLoading="searchCityLoading"
            @selected="setCity($event)"
          >
            <search-input-option
              v-for="(row, index) in searchCityResults.data"
              :key="index"
              :index="index"
              @click="setCity(row)"
            >
              <div>
                {{ row.city }} - {{ row.state }}
                <br />
              </div>
            </search-input-option>
          </search-input>
        </div>

        <div class="col-md-2">
          <text-input v-model="form.state.value" :alias="form.state.alias" :disabled="true" />
        </div>
      </div>

      <br />
      <br />
      <!-- contact -->
      <div class="row">
        <div class="col-md-3">
          <h5 class="text-primary">
            <i class="fas fa-phone-alt" /> Contato
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col-6 col-md-3">
          <mask-input v-model="form.phone_wa.value" :mask="'phone'" :alias="form.phone_wa.alias" />
        </div>

        <div class="col-6 col-md-3">
          <mask-input v-model="form.phone2.value" :mask="'phone'" :alias="form.phone2.alias" />
        </div>
        <div class="col-6 col-md-3">
          <mask-input v-model="form.phone3.value" :mask="'phone'" :alias="form.phone3.alias" />
        </div>
        <div class="col-6 col-md-3">
          <mask-input v-model="form.phone4.value" :mask="'phone'" :alias="form.phone4.alias" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <text-input v-model="form.email1.value" :alias="form.email1.alias" />
        </div>
        <div class="col-md-4">
          <text-input v-model="form.email2.value" :alias="form.email2.alias" />
        </div>
        <div class="col-md-4">
          <text-input v-model="form.website.value" :alias="form.website.alias" />
        </div>
      </div>
      <br />
      <br />
      <!-- CRIAR TABELA FISCAL NO BANCO  -->
      <div class="row">
        <div class="col-md-3">
          <h5 class="text-primary">
            <i class="fas fa-file-invoice" /> Informações Fiscais
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <text-input v-model="form.cnae.value" :alias="form.cnae.alias" />
        </div>
        <div class="col-md-6">
          <text-input :value="crt[form.crt.value]" :alias="form.crt.alias" :disabled="true" />
        </div>
        </div>

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "./../../mixins/Form.js";

export default {
  data: function() {
    return {
      form: new Form({
        id: {},

        name: {
          alias: "Razão Social",
          validate: { required: true }
        },

        alias: {
          alias: "Nome Fantasia"
        },

        cnpj: {
          alias: "Cnpj"
        },

        inscricao_estadual: {
          alias: "Inscrição Estadual"
        },

         inscricao_estadual_isento: {
          value: 1
        },

        inscricao_municipal: {
          alias: "Inscrição Municipal"
        },

        //Address
        address: {
          alias: "Endereço"
        },

        number: {
          alias: "Numero"
        },

        complement: {
          alias: "Complemento"
        },
        district: {
          alias: "Bairro"
        },
        zipcode: {
          alias: "Cep"
        },
        city_id: {
          alias: "Cidade"
        },
        city: {
          alias: {}
        },

        state: {
          alias: "Estado"
        },

        //contact
        phone_wa: {
          alias: "Telefone"
        },


        phone2: {
          alias: "Telefone"
        },

        phone2_is_whatsapp: {
          alias: "phone2_is_whatsapp"
        },

        phone3: {
          alias: "Telefone"
        },

        phone3_is_whatsapp: {
          alias: "phone3_is_whatsapp"
        },

        phone4: {
          alias: "Telefone"
        },

        phone4_is_whatsapp: {
          alias: "phone4_is_whatsapp"
        },

        email1: {
          alias: "Email"
        },

        email2: {
          alias: "Email"
        },

        website: {
          alias: "Site"
        },

       // INFORMAÇÕES FISCAIS
          cnae: {
          alias: "Cnae"
        },

          crt: {
          alias: "Código de Regime Tributário"
        }
      }),

      crt : {
        1 : 'Simples nacional',
        2 : 'Simples nacional com excesso de sublimite de receita bruta',
      },

      searchCityResults: {},

      searchCityLoading: false
    };
  },

  methods: {
    open(company) {
      this.$refs.modal.show();

      this.form.setValues(company);
    },

    store() {
      if (this.form.isValid()) {

        this.$store.commit("showLoading");

        var message =
          "O cadastro de " + this.form.name.value + " foi atualizado!";

        axios
          .post("api/company/store", this.form.getValues())
          .then(response => {
            this.$refs.modal.hide();

            this.$emit("stored", this.form.getValues());

            //this.makeToast('success')
            this.$store.commit("showAlert", {
              message: message,
              type: "success"
            });

            this.$store.commit("hideLoading");
          })
          .catch(error => {
            this.error = error;

            this.$store.commit("hideLoading");
          });
      }
    },

    searchCity(search) {
      this.searchCityLoading = true;

      axios
        .post("api/city/selectAll?page=" + search.page, { city: search.text })
        .then(response => {
          this.searchCityResults = response.data;

          this.searchCityLoading = false;
        })
        .catch(error => {
          this.error = error;
        });
    },

    setCity(city) {
      this.form.city_id.value = city.id;

      this.form.city.value = city.city;

      this.form.state.value = city.state;
    }
  }
};
</script>


